/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendDiscountRateDto } from '../models/backend-discount-rate-dto';
import { BackendIdDto } from '../models/backend-id-dto';
import { projectTaxesDiscountRatesCreate } from '../fn/discount-rate/project-taxes-discount-rates-create';
import { projectTaxesDiscountRatesCreate$FormData } from '../fn/discount-rate/project-taxes-discount-rates-create-form-data';
import { ProjectTaxesDiscountRatesCreate$FormData$Params } from '../fn/discount-rate/project-taxes-discount-rates-create-form-data';
import { ProjectTaxesDiscountRatesCreate$Params } from '../fn/discount-rate/project-taxes-discount-rates-create';
import { projectTaxesDiscountRatesCreate$XWwwFormUrlencoded } from '../fn/discount-rate/project-taxes-discount-rates-create-x-www-form-urlencoded';
import { ProjectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Params } from '../fn/discount-rate/project-taxes-discount-rates-create-x-www-form-urlencoded';
import { projectTaxesDiscountRatesDestroy } from '../fn/discount-rate/project-taxes-discount-rates-destroy';
import { ProjectTaxesDiscountRatesDestroy$Params } from '../fn/discount-rate/project-taxes-discount-rates-destroy';
import { projectTaxesDiscountRatesList } from '../fn/discount-rate/project-taxes-discount-rates-list';
import { ProjectTaxesDiscountRatesList$Params } from '../fn/discount-rate/project-taxes-discount-rates-list';
import { projectTaxesDiscountRatesPartialUpdate } from '../fn/discount-rate/project-taxes-discount-rates-partial-update';
import { projectTaxesDiscountRatesPartialUpdate$FormData } from '../fn/discount-rate/project-taxes-discount-rates-partial-update-form-data';
import { ProjectTaxesDiscountRatesPartialUpdate$FormData$Params } from '../fn/discount-rate/project-taxes-discount-rates-partial-update-form-data';
import { ProjectTaxesDiscountRatesPartialUpdate$Params } from '../fn/discount-rate/project-taxes-discount-rates-partial-update';
import { projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded } from '../fn/discount-rate/project-taxes-discount-rates-partial-update-x-www-form-urlencoded';
import { ProjectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/discount-rate/project-taxes-discount-rates-partial-update-x-www-form-urlencoded';
import { projectTaxesDiscountRatesRetrieve } from '../fn/discount-rate/project-taxes-discount-rates-retrieve';
import { ProjectTaxesDiscountRatesRetrieve$Params } from '../fn/discount-rate/project-taxes-discount-rates-retrieve';
import { projectTaxesDiscountRatesUpdate } from '../fn/discount-rate/project-taxes-discount-rates-update';
import { projectTaxesDiscountRatesUpdate$FormData } from '../fn/discount-rate/project-taxes-discount-rates-update-form-data';
import { ProjectTaxesDiscountRatesUpdate$FormData$Params } from '../fn/discount-rate/project-taxes-discount-rates-update-form-data';
import { ProjectTaxesDiscountRatesUpdate$Params } from '../fn/discount-rate/project-taxes-discount-rates-update';
import { projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded } from '../fn/discount-rate/project-taxes-discount-rates-update-x-www-form-urlencoded';
import { ProjectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Params } from '../fn/discount-rate/project-taxes-discount-rates-update-x-www-form-urlencoded';
import { projectTaxesUnblockDiscountRatesCreate } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create';
import { projectTaxesUnblockDiscountRatesCreate$FormData } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create-form-data';
import { ProjectTaxesUnblockDiscountRatesCreate$FormData$Params } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create-form-data';
import { ProjectTaxesUnblockDiscountRatesCreate$Params } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create';
import { projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create-x-www-form-urlencoded';
import { ProjectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Params } from '../fn/discount-rate/project-taxes-unblock-discount-rates-create-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiDiscountRateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectTaxesDiscountRatesList()` */
  static readonly ProjectTaxesDiscountRatesListPath = '/api/project_taxes/discount_rates/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesList$Response(
    params?: ProjectTaxesDiscountRatesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendDiscountRateDto>>> {
    return projectTaxesDiscountRatesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesList(
    params?: ProjectTaxesDiscountRatesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendDiscountRateDto>> {
    return this.projectTaxesDiscountRatesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendDiscountRateDto>>): Array<BackendDiscountRateDto> => r.body),
    );
  }

  /** Path part for operation `projectTaxesDiscountRatesCreate()` */
  static readonly ProjectTaxesDiscountRatesCreatePath = '/api/project_taxes/discount_rates/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesCreate$Response(
    params: ProjectTaxesDiscountRatesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesCreate(
    params: ProjectTaxesDiscountRatesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesCreate$XWwwFormUrlencoded(
    params: ProjectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesCreate$FormData$Response(
    params: ProjectTaxesDiscountRatesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesCreate$FormData(
    params: ProjectTaxesDiscountRatesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesDiscountRatesRetrieve()` */
  static readonly ProjectTaxesDiscountRatesRetrievePath = '/api/project_taxes/discount_rates/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesRetrieve$Response(
    params: ProjectTaxesDiscountRatesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesRetrieve(
    params: ProjectTaxesDiscountRatesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesDiscountRatesUpdate()` */
  static readonly ProjectTaxesDiscountRatesUpdatePath = '/api/project_taxes/discount_rates/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesUpdate$Response(
    params: ProjectTaxesDiscountRatesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesUpdate(
    params: ProjectTaxesDiscountRatesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesUpdate$FormData$Response(
    params: ProjectTaxesDiscountRatesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesUpdate$FormData(
    params: ProjectTaxesDiscountRatesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesDiscountRatesDestroy()` */
  static readonly ProjectTaxesDiscountRatesDestroyPath = '/api/project_taxes/discount_rates/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesDestroy$Response(
    params: ProjectTaxesDiscountRatesDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return projectTaxesDiscountRatesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectTaxesDiscountRatesDestroy(
    params: ProjectTaxesDiscountRatesDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.projectTaxesDiscountRatesDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `projectTaxesDiscountRatesPartialUpdate()` */
  static readonly ProjectTaxesDiscountRatesPartialUpdatePath = '/api/project_taxes/discount_rates/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesPartialUpdate$Response(
    params: ProjectTaxesDiscountRatesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesDiscountRatesPartialUpdate(
    params: ProjectTaxesDiscountRatesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded(
    params: ProjectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesDiscountRatesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesPartialUpdate$FormData$Response(
    params: ProjectTaxesDiscountRatesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendDiscountRateDto>> {
    return projectTaxesDiscountRatesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesDiscountRatesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesDiscountRatesPartialUpdate$FormData(
    params: ProjectTaxesDiscountRatesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendDiscountRateDto> {
    return this.projectTaxesDiscountRatesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendDiscountRateDto>): BackendDiscountRateDto => r.body),
    );
  }

  /** Path part for operation `projectTaxesUnblockDiscountRatesCreate()` */
  static readonly ProjectTaxesUnblockDiscountRatesCreatePath = '/api/project_taxes/unblock-discount-rates/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockDiscountRatesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesUnblockDiscountRatesCreate$Response(
    params: ProjectTaxesUnblockDiscountRatesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockDiscountRatesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockDiscountRatesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectTaxesUnblockDiscountRatesCreate(
    params: ProjectTaxesUnblockDiscountRatesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockDiscountRatesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Response(
    params: ProjectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded(
    params: ProjectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockDiscountRatesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectTaxesUnblockDiscountRatesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesUnblockDiscountRatesCreate$FormData$Response(
    params: ProjectTaxesUnblockDiscountRatesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return projectTaxesUnblockDiscountRatesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectTaxesUnblockDiscountRatesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  projectTaxesUnblockDiscountRatesCreate$FormData(
    params: ProjectTaxesUnblockDiscountRatesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.projectTaxesUnblockDiscountRatesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
